import { FlexColumn, FlexRow } from '@gorila-shared-ui/components';
import { Modal, ModalBody, ModalHeader } from 'baseui/modal';
import { memo, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useStyles } from '../../../hooks/useStyles';
import { MaintenanceConfiguration } from '../../../types/maintenances';
import { MaintenanceConfigurationForm } from './MaintenanceConfigurationForm';

type Props = {
  isOpen: boolean;
  selectedMaintenanceConfiguration?: MaintenanceConfiguration;
  onClose: (update?: boolean) => void;
};

function MaintenanceConfigurationModal({ onClose, isOpen, selectedMaintenanceConfiguration }: Props) {
  const { css } = useStyles();
  const [maintenanceConfiguration, setMaintenanceConfiguration] = useState<MaintenanceConfiguration>();

  useEffect(() => {
    if (!selectedMaintenanceConfiguration) {
      setMaintenanceConfiguration(undefined);
      return;
    } else {
      setMaintenanceConfiguration(selectedMaintenanceConfiguration);
    }
  }, [selectedMaintenanceConfiguration]);

  return createPortal(
    <Modal
      animate
      closeable
      onClose={() => onClose()}
      isOpen={isOpen}
      size="auto"
    >
      <FlexRow
        gap={0}
        classNames={css({
          justifyContent: 'space-between',
          margin: '6px 2rem 0px 0px',
        })}
      >
        <ModalHeader
          className={css({
            marginBottom: '0 !important',
          })}
        >
          {maintenanceConfiguration?.name ?? 'Nueva configuración'}
        </ModalHeader>
      </FlexRow>
      <ModalBody>
        <FlexColumn
          classNames={css({
            width: '70vw',
            maxWidth: '600px',
            minWidth: '350px',
            boxSizing: 'border-box',
            padding: '1rem',
            borderTop: '1px solid rgb(226, 226, 226)',
            maxHeight: '80vh',
          })}
        >
          <MaintenanceConfigurationForm
            maintenanceConfiguration={maintenanceConfiguration}
            onCancel={() => onClose(false)}
            afterSave={() => onClose(true)}
          />
        </FlexColumn>
      </ModalBody>
    </Modal>,
    document.body
  );
}

export default memo(MaintenanceConfigurationModal);
